export const CTA_BLOCK_s4 =  {
  "blockType": "CTA",
  "blockDesign": "CTADesign1",
  "editFormName": "CTA_01_FORM",
  "styleProps": {
    "background-color": "#081318",
    "padding": "120px 20px 120px 20px",
    "background-image": "linear-gradient(to bottom,#081318,#0C3528)"
  },
  "headings": [
    {
      "text": "Get started today",
      "styleProps": {
        "text-align": "center",
        "font-size": "4.5rem",
        "line-height": "1",
        "padding": "50px 0px 30px 0px",
        "color": "#FBFBFB",
        "font-family-cust": "",
        "font-family": "'Nunito', sans-serif",
        "font-family-bk": "'Nunito', sans-serif"
      },
      "alignStyleProps": {
        "text-align": "left"
      },
      "stylePropsTab": {
        "font-size": "3rem",
        "line-height": "1"
      },
      "stylePropsMob": {
        "font-size": "2.25rem",
        "line-height": "2.5rem"
      }
    },
    {
      "text": "Ready to unlock your business potential? Get in touch with us today to explore how our software solutions can drive growth, improve efficiency, and enhance customer experiences.",
      "styleProps": {
        "text-align": "left",
        "padding": "10px 0px 10px 0px",
        "color": "#cccccc",
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "margin": "0px 0px 40px 0px"
      },
      "alignStyleProps": {
        "text-align": "left",
        "max-width": "896px"
      }
    }
  ],
  "showBtnSec": true,
  "btnSecStyleProps": {
    "justify-content": "left"
  },
  "btnSecStylePropsTab": {},
  "btnSecStylePropsMob": {},
  "buttons": [
    {
      "text": "GET STARTED  ➜",
      "alt": "Click Here",
      "href": "https://yahoo.com",
      "styleProps": {
        "background-color": "#ADFF85",
        "color": "#333333",
        "border-color": "#3b82f680",
        "border-radius": "1rem",
        "padding": "18px 40px 18px 40px",
        "border-width": "0px"
      },
      "openType": "sametab"
    },
    {
      "text": "CONTACT US ➜",
      "styleProps": {
        "color": "#333333",
        "border-color": "#3b82f680",
        "background-color": "#ffffff",
        "border-width": "0px",
        "border-radius": "1rem",
        "padding": "18px 40px 18px 40px"
      },
      "href": "",
      "openType": "sametab"
    }
  ],
  "showEmailSec": true,
  "emailSecStyleProps": {},
  "subscription": {
    "showSection": "hide",
    "display": "enable",
    "subConfigs": {
      "configType": "convertkit",
      "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
      "configPlaceholder": ""
    },
    "email_placeholder": {
      "text": "example@mail.com"
    },
    "buttonText": {
      "text": "Subscribe",
      "styleProps": {
        "background-color": "#1b1b31",
        "color": "#ffffff"
      }
    },
    "successMessage": {
      "text": "Thank you for the signup",
      "styleProps": {}
    },
    "errorMessage": {
      "text": "Something went wrong. Please try again.",
      "styleProps": {}
    }
  },
  "metaDataId": 1746189482373,
  "afterIndex": 7,
  "blockId": 1746189482373,
  "containerStyleProps": {
    "padding": "0px 20px 0px 20px",
    "max-width": "1280px",
    "margin": "0px auto 0px auto"
  },
  "containerStylePropsTab": {
    "padding": "0px 0px 0px 0px"
  },
  "fonts": {
    "headings": [
      ""
    ]
  },
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  }
}